import React, { useState } from 'react';
import Filter from './Filter';
import MainTable from './MainTable';
import withLocation from '@helpers/hoc/withLocation';
import isMobile from '@helpers/hoc/isMobile';

import PlayRuleTitle from '@components/common/playRuleTitle';

import Reference from '@components/common/reference';

const JiBenZouShi = ({ search, isMobile }) => {
  const [filter, setFilter] = useState(['count', 'line']);
  const [ball, setBall] = useState(0);
  const [openFilter, setOpenFilter] = useState(false);

  const { group } = search;

  let options = [
    { label: '遗漏', value: 'count' },
    { label: '拆线', value: 'line' },
    { label: '遗漏分成', value: 'hightLightCount' },
    { label: '分隔线', value: 'section' },
  ];

  if (group === 'KL10F') {
    options = [
      { label: '遗漏', value: 'count' },
      { label: '遗漏分成', value: 'hightLightCount' },
      { label: '分隔线', value: 'section' },
    ];
  }

  const content = [
    'Dr. - Draw number',
    'Winner No. - Winner Number',
    'Appear Times - Number of appear times',
    'Avg N/O Streak - Average no open streak count',
    'Lgt N/O Streak - Longest no open streak count',
    'Lgt Streak - Longest open streak',
  ];

  return (
    <>
      {!isMobile && <PlayRuleTitle title="基本走势" />}
      <Filter
        filter={filter}
        setFilter={setFilter}
        ball={ball}
        setBall={setBall}
        options={options}
        group={group}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
      />
      <Reference content={content} sticky={true} />
      <MainTable filter={filter} ball={ball} />
    </>
  );
};

export default withLocation(isMobile(JiBenZouShi));
